// ============================================
// Free Gift Selector
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  initFreeGiftSelector();
});

function initFreeGiftSelector() {
  var selector = document.getElementById('free-gift-selector');
  if (!selector) return;

  var options = selector.querySelectorAll('.free-gift-selector__option');

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      options.forEach(function (o) {
        o.classList.remove('free-gift-selector__option--selected');
        o.setAttribute('aria-checked', 'false');
      });
      option.classList.add('free-gift-selector__option--selected');
      option.setAttribute('aria-checked', 'true');
    });

    option.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        option.click();
      }
    });
  });

  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var isAddingGift = false;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event.source !== 'product-form') return;
    if (isAddingGift) return;

    var giftSelector = document.getElementById('free-gift-selector');
    if (!giftSelector) return;

    var selected = giftSelector.querySelector('.free-gift-selector__option--selected');
    if (!selected) return;

    var giftVariantId = selected.dataset.variantId;
    if (!giftVariantId) return;

    // Match the same quantity the customer selected in the product form
    var qtyInput = document.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]');
    var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;

    isAddingGift = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(giftVariantId, 10),
          quantity: quantity,
          properties: { _is_free_gift: 'true' }
        }]
      })
    })
      .then(function (response) {
        if (response.ok) {
          document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
        }
        return response;
      })
      .catch(function (e) {
        console.error('[FreeGift] Failed to add gift to cart:', e);
      })
      .finally(function () {
        isAddingGift = false;
      });
  });
}






// Patch scrolling-text-banner to render HTML entities (e.g. &nbsp;) as actual spaces
(function () {
  const _define = customElements.define.bind(customElements);
  customElements.define = function (name, constructor, options) {
    if (name === 'scrolling-text-banner') {
      constructor.prototype.initializeScrollingText = function () {
        const heroTitle = this.querySelector('.hero__title');
        if (!heroTitle) return;

        // textContent decodes &amp;nbsp; → &nbsp; (the HTML entity string)
        const textContent = heroTitle.textContent.trim();
        if (!textContent) return;

        heroTitle.innerHTML = '';

        const scrollingContainer = document.createElement('div');
        scrollingContainer.classList.add('scrolling-container');
        heroTitle.appendChild(scrollingContainer);

        for (let i = 0; i < 2; i++) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('scrolling-wrapper');

          for (let j = 0; j < this.itemIteration; j++) {
            const textWrapper = document.createElement('div');
            textWrapper.classList.add('scrolling-text');
            if (this.showDots == 'true') {
              // innerHTML interprets &nbsp; as a non-breaking space instead of literal text
              textWrapper.innerHTML = textContent + this.dot;
              textWrapper.style.marginRight = `${this.spacing}px`;
              textWrapper.style.gap = `${this.spacing}px`;
            } else {
              textWrapper.innerHTML = textContent;
              textWrapper.style.marginRight = `${this.spacing}px`;
            }
            wrapper.appendChild(textWrapper);
          }

          scrollingContainer.appendChild(wrapper);
        }

        this.setAnimationSpeed(scrollingContainer);
      };
    }
    return _define(name, constructor, options);
  };
})();
